export default __webpack_public_path__ + "static/media/WEB_MOTOYCOCHE_$500_330x330.50143534.png";